/*
 * サブシステム名：支払
 * 機能名：支払残高調整入力
 */

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import filter from '@/rahmen/utils/filters'
import effect from '@/rahmen/utils/effects'
import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDateBox = () => import('@/components/DdDateBox')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdTextBox = () => import('@/components/DdNumericBox')

export default {
  name: 'ShiharaiZandakaChoseiEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdDateBox,
    DdEditCommonBar,
    DdNumericBox,
    DdTextBox
  },
  data: () => ({
    id: 0,
    rec: {
      shiharaiYmdString: '',
      searchShiharaisakiId: null,
      konkaiShiharaiKingaku: null
    },
    choseiZandaka: null,
    shiharaiZandaka: null,
    zenkaiChoseiKingaku: null,
    invalidMessages: {},
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeOfEdit: 2,
    modeKengen: 2
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      shiharaisakiList: 'DDMasters/vwCMstTorihikisakiGetShiharaisaki'
    }),
    filteredShiharaisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.shiharaisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    shiharaiKingaku () {
      if (this.shiharaiZandaka == null || this.choseiZandaka == null) {
        return null
      }
      return this.choseiZandaka - this.shiharaiZandaka
    },
    isUpdate () {
      return this.modeOfEdit === 1 || this.modeOfEdit === 2
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1 || this.modeKengen === 0
    },
    isChange () {
      return [this.rec.searchShiharaisakiId, this.rec.shiharaiYmdString]
    }
  },
  created () {},
  mounted () {
    console.log('mounted')
    this.initialize()
  },
  watch: {
    isChange: function () {
      const self = this
      if (self.rec.searchShiharaisakiId !== null && self.rec.shiharaiYmdString !== '' && self.id === 0) {
        effect.loadStart()
        return new Promise((resolve) => {
          console.log(this.id)
          const conditions = {
            id: self.id,
            searchShiharaisakiId: self.rec.searchShiharaisakiId,
            shiharaiYmdString: self.rec.shiharaiYmdString
          }
          self.HttpClient
            .post('/api/v1/VwCD2payd0040/findZandaka', conditions)
            .then((data) => {
              if (data.payload) {
                self.shiharaiZandaka = data.payload.shiharaiZandaka
                self.zenkaiChoseiKingaku = data.payload.zenkaiChoseiKingaku
              }
              effect.loadComplete()
              resolve()
            })
        })
      }
    }
  },
  methods: {
    setId: function () {
      if (this.$route.params.id !== null && this.$route.params.id !== undefined) {
        this.id = this.$route.params.id
        if (this.id === '0') {
          this.id = 0
        }
      } else {
        this.id = 0
      }
    },
    getCloneTargetMethod: function () {
      return {
        rec: this.rec,
        choseiZandaka: this.choseiZandaka,
        shiharaiZandaka: this.shiharaiZandaka,
        zenkaiChoseiKingaku: this.zenkaiChoseiKingaku
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    fetchData: function () {
      console.log('fetchData')
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .post('/api/v1/VwCD2payd0040/findZandaka', { id: this.id })
          .then((data) => {
            if (data.payload) {
              this.rec = data.payload
              this.rec.shiharaiYmdString = filter.dateFormatter(data.payload.shiharaiYmd)
              if (!this.rec.shiharaiYmdString) {
                this.rec.shiharaiYmdString = ''
              }
              delete this.rec.shiharaiYmd

              this.shiharaiZandaka = data.payload.shiharaiZandaka
              this.choseiZandaka = data.payload.shiharaiZandaka + data.payload.konkaiShiharaiKingaku
              this.zenkaiChoseiKingaku = data.payload.zenkaiChoseiKingaku
            }
            resolve()
          })
      })
    },
    initialize: function () {
      this.setId()
      const self = this
      const opt = {
        loadMasters: ['vwcmsteigyoshojininlist', 'vwcmsttorihikisakigetshiharaisaki'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            resolve()
            self.rec = {
              shiharaiYmdString: '',
              searchShiharaisakiId: null,
              konkaiShiharaiKingaku: 0
            }
            self.shiharaiZandaka = null
            self.choseiZandaka = null
            self.zenkaiChoseiKingaku = null
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            resolve()
          })
        },
        existsIdMethod: () => {
          return this.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId === 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, opt)
      this.initializeForRegister(opt)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data().rec
            self.shiharaiZandaka = data().shiharaiZandaka
            self.choseiZandaka = data().choseiZandaka
            self.zenkaiChoseiKingaku = data().zenkaiChoseiKingaku
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post(`/api/v1/VwCD2payd0040/DeleteMulti?id=${self.id}`, self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.modeOfEdit = 0
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            console.log('registerResponsePromise', self.id)
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.rec.searchShiharaisakiId !== self.rec.searchShiharaisakiId || data.rec.shiharaiYmdString !== self.rec.shiharaiYmdString
        },
        getIdMethod: () => {
          console.log('getIdMethod', self.id)
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            console.log('continuousInputInitializePromise', id)
            console.log(JSON.stringify({ id: id }))
            self.id = id
            self.transition(1, { id: id }, self.initialize)
          })
        },
        getTransitionBackParams: function () {
          console.log('getTransitionBackParams', self.id)
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          console.log('isUpdateModeMethod', self.id)
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          console.log('★getSavedInputMethod★')
          return {
          }
        }
      }
      this.cloneData = this.getCloneTargetMethod()
      this.register(opt)
    },
    registerPromise: function () {
      let f

      this.rec.konkaiShiharaiKingaku = this.shiharaiKingaku

      if (this.id === 0) {
        console.log('★登録処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.post('/api/v1/VwCD2payd0040/CreateMulti', this.rec)
      } else {
        console.log('★更新処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.put(`/api/v1/VwCD2payd0040/UpdateMulti?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      console.log('validate start', this.cloneData)
      if (this.shiharaiKingaku <= 0) {
        console.log('shiharaiKingaku')
        this.$refs.choseiZandaka[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0105', ['登録調整額', 0]))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      console.log('validate OK')
      return true
    },
    deleteValidate: function () {
      console.log('cloneData', this.cloneData)
      console.log('validate OK')
      return true
    }
  }
}
